import { SITE_TITLE } from 'apps/sigma2-ui/src/constants/site-meta';

export const documentTitle = (pageTitle?: string) =>
  pageTitle ? `${pageTitle} | ${SITE_TITLE}` : SITE_TITLE;
